export const CEP_LENGTH = 8
